export default "__VITE_ASSET__CkGyIERu__"